<template>
    <np-input v-bind="$attrs" :required="isRequired" :check_config="false" :addon-class="addonClass" @enter="validateVAT"
              @addon-click="validateVAT" @addon3-click="$emit('search', modelValue)" :label="label" :help-text="helpText" v-model="keyword" @update="val => {$emit('update:modelValue', val); }" >
        <template #addon v-if="vat_valid_status === 3">
            <span><i class="fa fa-check"> </i></span>
        </template>
        <template #addon v-else-if="vat_valid_status === 2">
            <span class="error" ><i class="fa fa-times"> </i></span>
        </template>
        <template #addon v-else-if="vat_valid_status === 1">
            <span ><i class="fa fa-spinner fa-spin"> </i></span>
        </template>
        <template #addon v-else-if="vat_valid_status === 0 && showValidateButton">
            <span >{{lang('validate')}}</span>
        </template>
        <template #addon3 v-if="is_searchable && showValidateButton">
            <span ><i class="fa fa-search"> </i></span>
        </template>
    </np-input>
</template>
<script>
    import NPInput from './np-input.vue';
    import NpResponsive from "./np-responsive.vue";
    export default {
        name: 'np-vat',
        props: {
            label: String,
            value: {},
            modelValue: {},
            showValidateButton: {
                type: Boolean,
                default: false
            },
            is_searchable: {
                type: Boolean,
                default: false
            },
            reference: {},
            country: {
                type: String,
                default: 'GBR',
            },
            helpText: {
                type: String,
                default :'',
            },
        },
        components: {
            'np-input': NPInput,
        },
        data: function(){
            return {
                vat_valid_status: 0,
                keyword: '',
                addonClass: {},
                vat_cache: {},
                vat_status: {
                    reset: 0,
                    validating: 1,
                    error: 2,
                    success: 3,
                },
            }
        },
        created: function (){
            // This component should word without v-model binding
            this.keyword = this.modelValue;
        },
        methods: {
            validateVAT(vat) {
                let vm = this;
                let payload = {
                    reference: vm.reference,
                    country_code: vm.country,
                    vat_number: vat
                };

                payload = {...payload, ...this.reference}

                // const configs = {
                //     headers: {'X-Requested-With': 'XMLHttpRequest'}
                // };

                if(this.vat_cache.hasOwnProperty(vat)) {
                    this.vat_valid_status = (this.vat_cache[vat]['valid'] === true) ? this.vat_status.success : this.vat_status.error;

                } else {
                    this.vat_valid_status = this.vat_status.validating;

                    this.getAxiosInstance().post('/externalservices/validatevat', payload)  //, configs)
                        .then(response => {
                            const data = response.data;
                            this.vat_cache[vat] = data;
                            this.vat_valid_status = data['valid'] ? this.vat_status.success : this.vat_status.error;
                        })
                        .catch(error => {
                            this.vat_valid_status = this.vat_status.error;
                        })
                }
            },
            isRequired: function () {
                return this.check_config ? !!this.page_config_required : !!this.required;
            },
        },
        watch: {
            modelValue: function (val) {
                this.vat_valid_status = 0;
                this.keyword = val;
            },
            vat_valid_status: function (val) {
                if(val === this.vat_status.reset || val === this.vat_status.validating) {
                    this.addonClass = {}
                }
                if(val === this.vat_status.error) {
                    this.addonClass = {error: true}
                }
                if(val === this.vat_status.success) {
                    this.addonClass = {success: true}
                }
            }

        }
    }
</script>

<style scoped>

</style>